import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';

import { ManageClientSitesComponent } from '../shared/components/manage-client-sites/manage-client-sites.component';
import { ClientModalComponent } from '../shared/components/client-modal/client-modal.component';
import { SiteList, siteListResponse } from '../site-list/model/site-list.model';
import { clientListRequest, UsersList } from '../shared/models/user.model';
import { AdminService } from './../services/admin.service';
import { UsersService } from '../services/users.service';
import { UtilService } from '../services/util.service';
import { SiteService } from '../services/site.service';
import { PageTypes } from '../shared/const/enum';

import { ColumnMode, NgxDatatableModule } from '@swimlane/ngx-datatable';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounce } from 'lodash';

@Component({
  selector: 'app-client-list',
  standalone: true,
  imports: [
    NgxDatatableModule,
    NgbTooltip,
    FormsModule
  ],
  templateUrl: './client-list.component.html',
  styleUrl: './client-list.component.scss'
})
export class ClientListComponent {

  private utilService = inject(UtilService);
  private modalService = inject(BsModalService);
  private usersService = inject(UsersService);
  private siteService = inject(SiteService);
  private adminService = inject(AdminService);
  private router = inject(Router);

  clientList
  allClientList: SiteList[] = [];
  modalRef?: BsModalRef;
  searchModal: string;
  paginationModal: clientListRequest = {
    pagination: {
      page: 1,
      perPage: 10,
    },
    sort: {
      created_at: -1
    },
    query: {
      search: null,
    }
  };
  totalCount: number = 0;
  ColumnMode = ColumnMode;
  getSiteListSubscription: Subscription;
  siteDeleteSubscription: Subscription;
  oldSavedClientList: any = { list: [], totalCount: 0 };
  is_enable: boolean;
  userDeleteSubscription: Subscription;
  usersList: UsersList[] = [];

  constructor() {
    // this.usersService.getMasterUserDetails();
    this.utilService.sidebarAndHeaderConfig({
      header: true,
      sidebar: true,
    });
    this.changeSearchValue = debounce(this.changeSearchValue.bind(this), 300);
  }

  async ngOnInit() {
    this.paginationModal.pagination.page = await this.utilService.getPageNumber(PageTypes.clientListTable);
    const searchText = await this.utilService.getPageNumber(PageTypes.clientListSearchText);
    this.paginationModal.query.search = searchText === 1 ? null : searchText;
    this.searchModal = this.paginationModal.query.search;
    let siteListFilter = await this.utilService.getPageNumber(PageTypes.clientListTableFilter);
    const oldSavedClientList = await this.utilService.getPageNumber(PageTypes.clientListTableData);
    if (oldSavedClientList !== 1) {
      this.allClientList = oldSavedClientList.list;
      this.totalCount = oldSavedClientList.totalCount;
      this.oldSavedClientList = oldSavedClientList;
    }

    siteListFilter == 1 ? false : siteListFilter;
    this.setPage({
      offset: this.paginationModal.pagination.page - 1
    }, siteListFilter);

    this.usersService.addUser.subscribe((res) => {
      if (res) {
        this.getClientList()
      }
    })

  }

  setPage(event: any, shorting: any = false) {
    this.utilService.storePageNumber(PageTypes.clientListTable, event.offset + 1);
    this.paginationModal.pagination.page = event.offset + 1;
    shorting ? this.getClientList(shorting) : this.getClientList();
  }

  onChange(row) {
    const a: Subscription = this.adminService.updateStatus(row._id).subscribe({
      next: (res) => {
        if (res) {
          this.utilService.showErrorSuccess('Status updated successfully.');
        } else {
          this.utilService.showErrorInfo('Something wrong!');
        }
      }, error: (e) => console.log(e),
      complete: () => a.unsubscribe()
    })
  }

  changePassword(row) {
    this.router.navigate(['/client-settings/change-password'], { queryParams: { userID: row._id } });
  }

  openModalClient(row) {
    this.usersService.userData = row;
    this.usersService.clientModalType = row ? true : false;
    this.modalRef = this.modalService.show(ClientModalComponent, {
      class: 'modal-lg  modal-rounded modal-dialog-centered', backdrop: true, ignoreBackdropClick: true
    });
  }

  onDelete(row: any, i: any) {
    this.utilService.confirmationAlert('Delete', `Do you want to delete client  "${row.first_name}" ? `, (val: any) => {
      if (val) {
        this.userDeleteSubscription = this.usersService.deleteUser(row._id).subscribe({
          next: (res: UsersList) => {
            this.usersList.splice(i, 1);
            this.getClientList();
            if (res) {
              this.utilService.showErrorSuccess("", 'Users deleted successfully');
            } else {
              this.utilService.showErrorInfo("", 'Something wrong!');
            }
          },
          error: (e) => console.log(e),
          complete: () => this.userDeleteSubscription.unsubscribe()
        });
      }
    });
  }

  async changeSearchValue() {
    if (this.searchModal) {
      this.paginationModal.query.search = this.searchModal;
    } else {
      delete this.paginationModal.query.search;
    }
    await this.utilService.storePageNumber(PageTypes.clientListSearchText, this.searchModal)
    this.getClientList();
  }

  onSort(event: any): void {
    const sortField = event.sorts[0].prop;
    const sortDirection = event.sorts[0].dir;
    const number = this.paginationModal.pagination.page;
    this.paginationModal.pagination.page = 1;
    setTimeout(() => {
      this.paginationModal.pagination.page = number;
      this.utilService.storePageNumber(PageTypes.clientListTableFilter, { filedName: sortField, direction: sortDirection === 'asc' ? 1 : -1 });
      this.getClientList({ filedName: sortField, direction: sortDirection === 'asc' ? 1 : -1 })
    }, 100);
  }

  // openModelViewAllSite(row) {
  //   if (row.sites && row.sites.length > 0) {
  //     UtilService.allClientSiteData = row.sites;
  //     this.modalService.show(SiteListShowModelComponent, {
  //       class: 'modal-lg  modal-rounded modal-dialog-centered', backdrop: true, ignoreBackdropClick: true,
  //     });
  //   } else {
  //     this.utilService.showErrorMessage("No assign sites found.")
  //   }
  // }

  openModelManageAllSites(row) {
    UtilService.allClientSiteDataWithClientData = row;
    const modalRef: BsModalRef = this.modalService.show(ManageClientSitesComponent, {
      class: 'modal-lg  modal-rounded modal-dialog-centered', backdrop: true, ignoreBackdropClick: true,
    });

    modalRef.onHidden.subscribe(() => {
      this.getClientList();
    });
  }

  getClientList(shorting: any = false) {
    let params: any = this.paginationModal;
    if (shorting) {
      params.sort = {
        [shorting.filedName]: shorting.direction
      }
    }
    const data = this.siteService.getAllClientList(this.paginationModal).subscribe({
      next: (res: siteListResponse) => {
        if (res) {
          if (JSON.stringify(this.oldSavedClientList.list) !== JSON.stringify(res.list)) {
            this.allClientList = res.list;
            this.totalCount = res.totalCount;
            this.oldSavedClientList.list = this.paginationModal.pagination.page;
            this.utilService.storePageNumber(PageTypes.clientListTableData, { list: this.allClientList, totalCount: this.totalCount });
          }
        } else {
          this.utilService.showErrorInfo("", 'Something wrong!')
        }
      },
      error: (e) => console.log(e),
      complete: () => data.unsubscribe()
    });
  }

  ngOnDestroy(): void {
    if (this.getSiteListSubscription) this.getSiteListSubscription.unsubscribe();
    if (this.siteDeleteSubscription) this.siteDeleteSubscription.unsubscribe();
  }

}
